// src/features/legacy-reports/useLegacySubaccountsReport.ts

import { useQuery } from '@tanstack/react-query';
import { LegacyReportsApi } from './LegacyReportsApi';
import { LEGACY_REPORTS_QUERY_KEYS } from '@/lib/constants/legacyReports';
import type { LegacyAccountReport } from './types';

export interface UseLegacySubaccountsReportResult {
  report: LegacyAccountReport | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

/** Aggregated children of the parent account. Enable only for eligible parents. */
export function useLegacySubaccountsReport(
  cId: number | null,
  start: number,
  end: number,
  enabled: boolean
): UseLegacySubaccountsReportResult {
  const query = useQuery({
    queryKey: LEGACY_REPORTS_QUERY_KEYS.subaccounts(cId ?? 0, start, end),
    queryFn: () => LegacyReportsApi.getSubaccountsReport(cId!, start, end),
    enabled: enabled && cId !== null,
  });

  return {
    report: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
